export default {
      id: "i-close2-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/sprite.svg#i-close2",
      toString: function () {
        return this.url;
      }
    }